import React, { useState, useEffect } from 'react';
import FormField from '../../components/FormField';
import Error from '../../components/global/Error';
import Spinner from '../../components/global/Spinner';
import { useNavigate } from 'react-router-dom';
import { formIcons } from '../../constants/icons';
import { useDispatch, useSelector } from 'react-redux';
import { VerifyEmail, ResendVerificationCode } from '../../services/redux/auth/authAction/authAction';
import { useLocation } from 'react-router-dom';

const VerifyOtp = ({ setShowLoginModal }) => {
  const navigate = useNavigate();

  const location = useLocation();
  const email = location.state?.email;



  const { loading, userInfo, error, success } = useSelector(
    (state) => state.auth
    );

  




  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    email: email || '',
    token1: '',
    token2: '',
    token3: '',
    token4: '',
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  




  const submitForm = async (e) => {
    e.preventDefault();
    const concatenatedToken = `${formData.token1}${formData.token2}${formData.token3}${formData.token4}`;

    console.log(email, concatenatedToken)
  
    try {
      await dispatch(VerifyEmail({ email, token: concatenatedToken }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleResendClick = async () => {
    try {
      // Dispatch the ResendVerificationCode action with the user's email
      await dispatch(ResendVerificationCode('awe.petersq@gmail.com'));
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <div>
      <div className="relative flex min-h-screen flex-col justify-center overflow-hidden bg-gray-50 py-12">
  <div className="relative bg-white px-6 pt-10 pb-9 shadow-xl mx-auto w-full max-w-lg rounded-2xl">
    <div className="mx-auto flex w-full max-w-md flex-col space-y-16">
      <div className="flex flex-col items-center justify-center text-center space-y-2">
      <img src="https://mymedicalbank.com/landingPage/assets/images/logo2.png" width={200} className="mx-auto py-6" />
        <div className="font-semibold text-3xl">
          <p>Email Verification</p>
        </div>
        <div className="flex flex-row text-sm font-medium text-gray-400">
          <p>We have sent a code to your email {email}</p>
        </div>
      </div>

      <div>
        <form onSubmit={submitForm}>
          {error && <Error message = {error}>{error}</Error>}
          <div className="flex flex-col space-y-16">
            <div className="flex flex-row items-center justify-between mx-auto w-full max-w-xs">
            <div className="w-16 h-16 ">
                <input className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl
                 border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700" 
                 type="text" 
                 name="token1" 
                 value={formData.token1}
                 onChange={handleInputChange}
                 />
              </div>
              <div className="w-16 h-16 ">
                <input className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl
                 border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700" 
                 type="text" 
                 name="token2" 
                 value={formData.token2}
                 onChange={handleInputChange}
                 />
              </div>
              <div className="w-16 h-16 ">
                <input className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl
                 border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700" 
                 type="text" 
                 name="token3" 
                 value={formData.token3}
                 onChange={handleInputChange}
                 />
              </div>
              <div className="w-16 h-16 ">
                <input className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl
                 border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700" 
                 type="text" 
                 name="token4" 
                 value={formData.token4}
                 onChange={handleInputChange}
                 />
              </div>
            </div>

            <div className="flex flex-col space-y-5">
              <div>
                {loading ? 
                    <button type="submit" className="w-full text-black px-4 py-2 text-white font-medium bg-[#47A7FD] hover-bg-[#47A7FD]-500
                    active-bg-indigo-600 rounded duration-150
                        mr-2 mb-2" disabled={loading}>  
                          
                            <svg aria-hidden="true" className="inline w-8 h-8  text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                            </svg> 
                      </button>
                        :
                      <button 
                      type='submit' 
                      disabled = {loading}
                      className="flex flex-row items-center justify-center text-center w-full border rounded-xl outline-none
                      py-5 bg-[#47A7FD] hover-bg-[#47A7FD]-500
                      active-bg-indigo-600 rounded duration-150 border-none text-white text-sm shadow-sm">
                        Verify Code
                      </button>
                      }
              </div>

              <div className="flex flex-row items-center justify-center text-center text-sm font-medium space-x-1 text-gray-500">
                <p>Didn't recieve code?</p> <a className="flex flex-row items-center text-blue-600 cursor-pointer"  onClick={handleResendClick}>Resend</a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
    </div>
  );
};

export default VerifyOtp;
